<template>
  <v-container fluid>
    <!-- <v-container> -->
    <!-- <v-card-title> -->
    <!-- Airbox -->
    <v-spacer></v-spacer>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      hide-details
    ></v-text-field>
    <!-- </v-card-title> -->
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      dense
      :loading="loading"
      loading-text="Loading... Please wait"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:item.Status="{ item }">
        <!-- <router-link :to="{ name: 'PilotStatus', params: {id:item.RegId} }"> -->
        <v-btn :color="getColor(item.Status)" dark min-width="80" x-small rounded>
          {{ item.Status }}
          <!-- <v-badge icon="fa-globe" :value="item.HasPosition"></v-badge> -->
        </v-btn>
        <!-- </router-link> -->
      </template>
      <template v-slot:item.HasPosition="{ item }">
        <div v-if="item.HasPosition">
          <a :href="item.GoogleMapLink" target="_blank"><v-btn color="primary" rounded x-small><v-icon x-small>fa-globe</v-icon></v-btn></a>
        </div>
      </template>
    </v-data-table>
    <!-- </div> -->
  </v-container>
</template>

<script>

export default {
  // name: "LsbTable",
  // props: {
  //   eventId: {
  //     type: String
  //   }
  // },
  name: 'AirboxTable',
    props: {
        items: {
            type: Array
        }
    },
  data() {
    return {
      search: "",
      loading: true,
      dialog: false,
      pid: null,
      headers: [
        // { text: "Date", value: "Dato" },
        { text: "Event", value: "Event" },
        { text: "Name", value: "Name" },
        { text: "Status", value: "Status" },
        { text: "Google Map", value: "HasPosition" },
        { text: "Time", value: "Tid" },
        { text: "", value: "Active" },
        { text: "Msg", value: "Message" }
        // { text: "Mobile", value: "MID" },
        // { text: "Id", value: "RegId" }
      ],
      // items: [],
      // errors: []
    };
  },
  created() {
    //
    this.loading = false;
  },
  methods: {
    getColor(Status) {
      if (Status === "START") return "red";
      else if (Status === "LANDED") return "orange";
      else return "green";
    },
    editStatus(pid) {
      console.log(pid);
      this.pid = pid;
      console.log("/airbox/pilotstatus/", pid);
      this.dialog = true;
    }
  }
};
</script>
